<div class="content-info">
  <div class="zf-doc-head zf-doc-head--bare">
    <div class="zf-doc-left">
      <a class="zf-doc-back" href="#/product-list"><i class="bi bi-arrow-left"></i> Products</a>
      <div class="zf-doc-title-row"><h3 class="zf-doc-title">{{ title }}</h3></div>
    </div>
  </div>
  <div class="container mt-3 common-stepper">
    <ul class="nav nav-pills nav-justified flex-row mb-4" id="stepper">
      <li class="nav-item">
        <a class="nav-link active" data-bs-toggle="pill" href="#step1">1. Basic Info</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-bs-toggle="pill" href="#step2">2. Variants</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-bs-toggle="pill" href="#step3">3. Review & Submit</a>
      </li>
    </ul>

    <div class="tab-content">
      <!-- Step 1 -->
      <div class="tab-pane fade show active" id="step1">
        <form [formGroup]="productForm" class="input-fileds">
          <div class="product-catg">
            <h2>Item Info</h2>
            <div class="catg-fileds">
              <div class="row">
                <!-- <div class="col-md-3 form-group">
                    <label class="form-label">Name</label>
                    <input type="text" class="form-control" formControlName="name" />
                    <div *ngIf="productForm.get('name')?.errors && productForm.get('name')?.touched" class="text-danger">
                      <div *ngIf="productForm.get('name')?.errors?.['required']">Name is required</div>
                    </div>
                  </div> -->
                <div class="col-md-3 form-group">
                  <label class="form-label">SKU Code</label>
                  <input type="text" class="form-control" formControlName="sku" [readonly]="true" />
                  @if ( productForm.get('sku')?.touched &&
                  productForm.get('sku')?.hasError('required') ) {
                  <div class="text-danger">SKU is required.</div>
                  }
                </div>
                <div class="col-md-3 form-group">
                  <label class="form-label">Short Description</label>
                  <input type="text" class="form-control" formControlName="shortDescription" />
                  @if ( productForm.get('shortDescription')?.errors &&
                  productForm.get('shortDescription')?.touched ) {
                  <div class="text-danger">
                    @if
                    (productForm.get('shortDescription')?.errors?.['required'])
                    {
                    <div>Short Description is required</div>
                    }
                  </div>
                  }
                </div>
                <div class="col-md-3 form-group">
                  <label class="form-label">Long Description</label>
                  <textarea class="form-control" formControlName="longDescription"></textarea>
                  @if ( productForm.get('longDescription')?.errors &&
                  productForm.get('longDescription')?.touched ) {
                  <div class="text-danger">
                    @if
                    (productForm.get('longDescription')?.errors?.['required']) {
                    <div>Long Description is required</div>
                    }
                  </div>
                  }
                </div>
                <!-- <div class="col-md-3 form-group">
                  <label class="form-label">Manufacturer Name</label>
                  <input type="text" class="form-control" formControlName="manufacturerName" />
                </div> -->
                <div class="col-md-3 form-group">
                  <label class="form-label">Vendor</label>
                  <!-- <select class="form-control" formControlName="vendorsId">
                  <option *ngFor="let vendor of vendors" [value]="vendor.id">{{ vendor.name }}</option>
                </select> -->
                  <ng-select [items]="vendors" bindLabel="name" bindValue="id" [searchable]="true" [clearable]="true"
                    placeholder="Select Vendor" formControlName="vendorsId">
                  </ng-select>
                  @if ( productForm.get('vendorsId')?.errors &&
                  productForm.get('vendorsId')?.touched ) {
                  <div class="text-danger">
                    @if (productForm.get('vendorsId')?.errors?.['required']) {
                    <div>Vendor is required</div>
                    }
                  </div>
                  }
                </div>
                <div class="col-md-3 form-group">
                  <label class="form-label">Photo/Image URL</label>
                  <input type="text" class="form-control" formControlName="photoUrl" />
                </div>
                <div class="col-md-3 form-group">
                  <label class="form-label">Manufacturer</label>
                  <ng-select [items]="manufacturers" bindLabel="name" bindValue="id" [typeahead]="manufacturerInput$"
                    [loading]="isLoadingManufacturers" [clearable]="true" (change)="onManufacturerSelect($event)"
                    placeholder="Search Manufacturer" formControlName="manufacturerId">
                  </ng-select>
                </div>
                <div class="col-md-3 form-group">
                  <label class="form-label">Brand</label>
                  <ng-select [items]="brandOptions" bindLabel="name" bindValue="id" [searchable]="true"
                    [clearable]="true" placeholder="Select Brand" formControlName="brandId">
                  </ng-select>
                  @if ( productForm.get('brandId')?.errors &&
                  productForm.get('brandId')?.touched ) {
                  <div class="text-danger">
                    @if (productForm.get('brandId')?.errors?.['required']) {
                    <div>Brand is required</div>
                    }
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>

          <div class="product-catg">
            <h2>Category Information</h2>
            <div class="catg-fileds">
              <div class="row">
                <div class="col-md-3 form-group">
                  <label class="form-label">Department
                    <button type="button" class="btn btn-link plusbtn">
                      <i class="bi bi-plus-lg" (click)="openDepartmentModal()"></i>
                    </button>
                  </label>
                  <select class="form-control" formControlName="departmentId">
                    <option value="" disabled selected>
                      Select Department
                    </option>

                    @for (department of departments; track department) {
                    <option [value]="department.id">
                      {{ department.name }}
                    </option>
                    }
                  </select>
                  @if ( productForm.get('departmentId')?.errors &&
                  productForm.get('departmentId')?.touched ) {
                  <div class="text-danger">
                    @if (productForm.get('departmentId')?.errors?.['required'])
                    {
                    <div>Department is required</div>
                    }
                  </div>
                  }
                </div>
                <div class="col-md-3 form-group">
                  <label class="form-label">Category
                    <button type="button" class="btn btn-link plusbtn">
                      <i class="bi bi-plus-lg" (click)="openCategoryModal()"></i>
                    </button>
                  </label>
                  <select class="form-control" formControlName="categoryId">
                    <option value="" disabled selected>Select Category</option>
                    @for (category of categories; track category) {
                    <option [value]="category.id">
                      {{ category.name }}
                    </option>
                    }
                  </select>
                  @if ( productForm.get('categoryId')?.errors &&
                  productForm.get('categoryId')?.touched ) {
                  <div class="text-danger">
                    @if (productForm.get('categoryId')?.errors?.['required']) {
                    <div>Category is required</div>
                    }
                  </div>
                  }
                </div>
                <div class="col-md-3 form-group">
                  <label class="form-label">Sub Category
                    <button type="button" class="btn btn-link plusbtn">
                      <i class="bi bi-plus-lg" (click)="openSubCategoryModal()"></i>
                    </button>
                  </label>
                  <select class="form-control" formControlName="subCategoryId">
                    <option value="" disabled selected>
                      Select Sub Category
                    </option>
                    @for (sub of subCategories; track sub) {
                    <option [value]="sub.id">
                      {{ sub.name }}
                    </option>
                    }
                  </select>
                </div>
                <!-- <div class="col-md-3 form-group">
              <label class="form-label">Brand Name</label>
              <input type="text" class="form-control" formControlName="brandName" />
              <div *ngIf="productForm.get('brandName')?.errors && productForm.get('brandName')?.touched" class="text-danger">
                <div *ngIf="productForm.get('brandName')?.errors?.['required']">Brand name is required</div>
              </div>
            </div> -->
              </div>
            </div>
          </div>

          <div class="product-catg">
            <h2>Item Properties</h2>
            <div class="catg-fileds">
              <div class="row">
                <div class="col-md-3 form-group">
                  <label class="form-label">Is Perishable</label>
                  <select class="form-control" formControlName="isPerishable">
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>
                <div class="col-md-3 form-group">
                  <label class="form-label">Is Temperature Controlled</label>
                  <select class="form-control" formControlName="isTemperatureControlled">
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>
                <div class="col-md-3 form-group">
                  <label class="form-label">Shelf Life (in days)</label>
                  <input type="number" class="form-control" formControlName="shelfLifeDays" />
                </div>
                <div class="col-md-3 form-group">
                  <label class="form-label">Minimum Shelf Life (in days)</label>
                  <input type="number" class="form-control" formControlName="minShelfLifeDays" />
                </div>
                <div class="col-md-3 form-group">
                  <label class="form-label">Minimum Shelf Life (%)</label>
                  <input type="number" class="form-control" formControlName="minShelfLifePercent" />
                </div>
                <div class="col-md-3 form-group">
                  <label class="form-label">Batch Controlled</label>
                  <select class="form-control" formControlName="requiresBatchExpiryTracking">
                    <option [value]="true">Yes</option>
                    <option [value]="false">No</option>
                  </select>
                </div>
                <div class="col-md-3 form-group">
                  <label class="form-label">Serial Number Controlled</label>
                  <select class="form-control" formControlName="serialNumberControlled">
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>

                <div class="col-md-3">
                  <div class="form-check form-group">
                    <input type="checkbox" class="form-check-input" formControlName="isActive" />
                    <label class="form-label">Is Active</label>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-check form-group">
                    <input type="checkbox" class="form-check-input" formControlName="flowThrough" />
                    <label class="form-label">Flow Through</label>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-check form-group">
                    <input type="checkbox" class="form-check-input" formControlName="returnToVendor" />
                    <label class="form-label">Return to Vendor</label>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-check form-group">
                    <input type="checkbox" class="form-check-input" formControlName="isConsumable" />
                    <label class="form-label">Is Consumable?</label>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-check form-group">
                    <input type="checkbox" class="form-check-input" formControlName="isDSD" />
                    <label class="form-label">Is DSD?</label>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-check form-group">
                    <input type="checkbox" class="form-check-input" formControlName="isKit" />
                    <label class="form-label">Is Kit Component?</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="product-catg">
            <h2>Tax Info</h2>
            <div class="catg-fileds">
              <div class="row">
                <div class="col-md-3 form-group">
                  <label class="form-label">HSN Code</label>
                  <input type="text" class="form-control" formControlName="hsnCode" />
                  @if ( productForm.get('hsnCode')?.errors &&
                  productForm.get('hsnCode')?.touched ) {
                  <div class="text-danger">
                    @if (productForm.get('hsnCode')?.errors?.['required']) {
                    <div>HSN Code is required</div>
                    } @if (productForm.get('hsnCode')?.errors?.['hsnNotNumeric']) {
                    <div>HSN Code must contain digits only</div>
                    } @if (productForm.get('hsnCode')?.errors?.['hsnMissingDigit']) {
                    <!-- Odd length is almost always a spreadsheet eating a
                         leading zero, so say that rather than "invalid". -->
                    <div>
                      HSN Code has
                      {{ productForm.get('hsnCode')?.errors?.['hsnMissingDigit'].length }}
                      digits — one is missing. Codes are 4, 6 or 8 digits.
                    </div>
                    } @if (productForm.get('hsnCode')?.errors?.['hsnLength']) {
                    <div>HSN Code must be 4, 6 or 8 digits</div>
                    }
                  </div>
                  }

                  <!-- Live check against the HSN master. Structure alone cannot
                       tell a real code from a fake one — HSN has no checksum,
                       so "12345678" passes every format rule. -->
                  @if (hsnChecking) {
                  <div class="form-text text-muted">Checking HSN…</div>
                  } @else if (hsnCheck && hsnCheck.master) {
                  <div class="form-text text-success">
                    ✓ {{ hsnCheck.master.description }}
                  </div>
                  } @else if (hsnCheck && hsnCheck.exists === false) {
                  <div class="form-text text-warning">
                    Not found in the HSN master list — check it on the
                    <a
                      href="https://services.gst.gov.in/services/searchhsnsac"
                      target="_blank"
                      rel="noopener"
                      >GST portal</a
                    >
                    before saving.
                  </div>
                  } @else if (hsnCheck && hsnCheck.suggestion) {
                  <div class="form-text text-warning">
                    Did you mean {{ hsnCheck.suggestion }}?
                  </div>
                  }
                </div>
                <div class="col-md-3 form-group">
                  <label class="form-label">Purchase GST Slab</label>
                  <select class="form-control" formControlName="purchaseGstRateId">
                    @for (slab of gstSlabs; track slab) {
                    <option [value]="slab.id">
                      {{ slab.displayLabel }}
                    </option>
                    }
                  </select>
                  @if ( productForm.get('purchaseGstRateId')?.errors &&
                  productForm.get('purchaseGstRateId')?.touched ) {
                  <div class="text-danger">
                    @if
                    (productForm.get('purchaseGstRateId')?.errors?.['required'])
                    {
                    <div>Purchase GST Slab is required</div>
                    }
                  </div>
                  }
                </div>
                <div class="col-md-3 form-group">
                  <label class="form-label">Margin (%)</label>
                  <input type="number" class="form-control" formControlName="marginPercentage" />
                </div>
                <!-- <div class="col-md-3 form-group">
            <label class="form-label">Sales GST Slab</label>
            <select class="form-control" formControlName="saleGstRateId">
              <option *ngFor="let slab of gstSlabs" [value]="slab.id">{{ slab.value }}</option>
            </select>
            <div *ngIf="productForm.get('saleGstRateId')?.errors && productForm.get('saleGstRateId')?.touched" class="text-danger">
              <div *ngIf="productForm.get('saleGstRateId')?.errors?.['required']">Sales GST Slab is required</div>
            </div>
          </div> -->
                <div class="col-md-3 form-check form-group">
                  <input type="checkbox" class="form-check-input" formControlName="cessApplicable" />
                  <label class="form-label">Cess Applicable</label>
                </div>
                @if (productForm?.get('cessApplicable')?.value) {
                <div class="col-md-3 form-group">
                  <label class="form-label">Cess Rate (%)</label>
                  <input type="number" class="form-control" formControlName="cessRate" />
                </div>
                }
              </div>
            </div>
          </div>

          <div class="product-catg">
            <h2>Packing</h2>
            <div class="catg-fileds">
              <div class="row items-center">
                <div class="col-md-3 form-group">
                  <label class="form-label">UOM</label>
                  <select class="form-control" formControlName="uom">
                    @for (unit of units; track unit) {
                    <option [value]="unit">
                      {{ unit }}
                    </option>
                    }
                  </select>
                  @if ( productForm.get('uom')?.errors &&
                  productForm.get('uom')?.touched ) {
                  <div class="text-danger">
                    @if (productForm.get('uom')?.errors?.['required']) {
                    <div>UOM is required</div>
                    }
                  </div>
                  }
                </div>
                <div class="col-md-3 form-group">
                  <label class="form-label">Inner Packaging</label>
                  <input type="number" class="form-control" formControlName="innerPackaging" />
                </div>
                <div class="col-md-3 form-group">
                  <label class="form-label">Outer Packaging</label>
                  <input type="number" class="form-control" formControlName="outerPackaging" />
                </div>
                <div class="col-md-3 form-group">
                  <label class="form-label">Product Payment Terms (Days)</label>
                  <input type="number" class="form-control" formControlName="productSpecificPaymentTerms" />
                </div>
                <div class="col-md-3">
                  <div class="form-check form-group">
                    <input type="checkbox" class="form-check-input" formControlName="requiresBatchExpiryTracking" />
                    <label class="form-label">Requires Batch Expiry Tracking</label>
                  </div>
                </div>
                <!-- Loose item sold by weight: qty becomes the weighed amount and
                     Selling Price is treated as price per UOM (e.g. ₹/kg). PLU for the
                     scale label is set per pricing row below. -->
                <div class="col-md-3 form-group">
                  <label class="form-label">Sold by weight? (loose item)</label>
                  <div class="form-check form-switch mt-2">
                    <input class="form-check-input" type="checkbox" id="isWeighableToggle"
                      formControlName="isWeighable" />
                    <label class="form-check-label ms-2" for="isWeighableToggle">
                      {{ productForm.get('isWeighable')?.value
                        ? "Yes — priced per " + (productForm.get('uom')?.value || 'kg')
                        : "No" }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="product-catg">
            <h2>Bulk Product Mapping</h2>
            <div class="catg-fileds">
              <div class="form-group mb-4">
                <div class="d-flex align-items-center">
                  <label for="isBulkToggle" class="form-label fw-bold me-2 mb-0">
                    Is Bulk?
                  </label>
                  <div class="form-check form-switch mb-0">
                    <input class="form-check-input" type="checkbox" id="isBulkToggle" [checked]="isBulk" #isBulkCheckbox
                      (change)="onIsBulkChange(isBulkCheckbox.checked)" />
                  </div>
                  <span class="ms-2 me-4">{{ isBulk ? "Yes" : "No" }}</span>

                  <label for="showBulkProductsDetails" class="form-label fw-bold me-2 mb-0">
                    Show Bulk Products?
                  </label>
                  <div class="form-check form-switch mb-0">
                    <input class="form-check-input" type="checkbox" id="showBulkProductsDetails"
                      [checked]="showBulkProductsDetails" #showBulkCheckbox (change)="
                        onShowBulkProductsDetailsChange(
                          showBulkCheckbox.checked
                        )
                      " />
                  </div>
                  <span class="ms-2 me-4">{{
                    showBulkProductsDetails ? "Yes" : "No"
                    }}</span>
                </div>
              </div>
            </div>
            @if (showBulkProductsDetails) {
            <div class="product-catg">
              <h2>Bulk Product Fields</h2>
              <div class="catg-fileds">
                <div class="row mb-3">
                  <div class="col-md-3">
                    <label class="form-label">Bulk Parent Product</label>
                    <ng-select [items]="parentProducts" bindLabel="sku" bindValue="id" [searchable]="true"
                      [typeahead]="parentProductSearch$" [loading]="isLoadingParentProducts" [clearable]="true"
                      placeholder="Search By SKU code" formControlName="bulkParentProductId"
                      (change)="onParentProductSelect($event)">
                    </ng-select>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label">Search Product Name</label>
                    <ng-select [items]="parentProductsByName" bindLabel="shortDescription" bindValue="id"
                      [searchable]="true" [typeahead]="parentProductNameSearch$" [clearable]="true"
                      [loading]="isLoadingParentProductsByName" placeholder="Search by Product Name"
                      formControlName="bulkParentProductId" (change)="onParentProductNameSelect($event)">
                    </ng-select>
                  </div>
                  <!-- <div class="col-md-3">
                  <label class="form-label">Custom Size</label>
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Custom size (gm)"
                      formControlName="packSizeGm"
                      />
                  </div>
                </div> -->
                </div>
              </div>
            </div>
            }
          </div>
        </form>

        <div class="stepr-btns">
          <button type="button" class="btn btnsecondary" (click)="clearForm()">Clear</button>
          <button type="button" class="btn btnprimary" (click)="goToStep(2)">Next</button>
        </div>
      </div>

      <!-- Step 2: Variants -->
      <div class="tab-pane fade" id="step2">
        <form [formGroup]="productForm" class="input-fileds">
          <div formArrayName="variants" class="mt-3">
            @for (variant of variants.controls; track i; let i = $index) {
            <div [formGroupName]="i" class="border p-3 mb-2 rounded">
              <div class="variant-title">
                <h5>Variant {{ i + 1 }}</h5>
                <button type="button" class="btn btn-danger btn-sm mt-2" (click)="removeVariant(i)">
                  Remove Variant
                </button>
              </div>
              <div class="row items-center">
                <div class="col-12 col-sm-6 col-md-3 form-group">
                  <label class="form-label">Variant Name</label>
                  <input type="text" class="form-control" formControlName="variantName" />
                </div>
                <div class="col-12 col-sm-6 col-md-3 form-group">
                  <label class="form-label">Color</label>
                  <input type="text" class="form-control" formControlName="color" />
                </div>
                <div class="col-12 col-sm-6 col-md-3 form-group">
                  <label class="form-label">Size</label>
                  <input type="text" class="form-control" formControlName="size" />
                </div>
                <div class="col-12 col-sm-6 col-md-3 form-group">
                  <label class="form-label">Weight</label>
                  <input type="number" class="form-control" formControlName="weight" />
                </div>
                <div class="row items-center">
                  <!--
                    The EAN is authored per PRICING row (below), not on the
                    variant: a reprinted pack usually carries a new EAN AND a
                    new MRP, so the code belongs to the price it sells at.
                    There is no variant- or product-level copy of it.
                  -->
                  <div class="col-12 col-md-6 form-group">
                    <div class="d-flex align-items-center gap-2 flex-wrap mt-md-4">
                      <button type="button" class="btn btn-sm btn-success" (click)="cloneVariant(i)"
                        title="Clone Variant">
                        <i class="bi bi-plus-lg"></i> Clone Variant
                      </button>
                    </div>
                  </div>
                  <div class="col-12 col-md-3">
                    <div class="form-check form-group mt-md-4"> <!-- mt-md-4 aligns with inputs -->
                      <input type="checkbox" class="form-check-input" formControlName="isActive" />
                      <label class="form-label">Active</label>
                    </div>
                  </div>
                  <!-- Barcodes: identity, independent of pricing. Only for a
                       saved variant; a new product tags its codes on the
                       pricing row or on the Bulk EAN grid afterwards. -->
                  @if (isEdit) {
                  <div class="mt-2 col-12">
                    <app-variant-barcodes-panel
                      [variantId]="variant.get('id')?.value ?? null"
                      [sku]="productForm.get('sku')?.value ?? null"
                    ></app-variant-barcodes-panel>
                  </div>
                  }
                  <!-- Pricing Section -->
                  <div formArrayName="pricing" class="mt-2 col-12">
                    <div class="variant-title">
                      <h6>Pricing</h6>
                      <button type="button" class="btn btnprimary btn-sm" (click)="addPricing(i)">
                        Add Pricing
                      </button>
                    </div>
                    @for ( price of getPricingControls(i).controls; track j;
                    let j = $index) {
                    <div [formGroupName]="j" class="border p-2 mb-2 rounded">
                      <div class="row">
                        <div class="row g-2 align-items-end">
                          <div class="col-12 col-sm-6 col-md-3">
                            <div class="p-2">
                              <label class="mb-2">Base Price</label>
                              <input type="number" step="0.0001" class="form-control" formControlName="basePrice"
                                (input)="calculatePricing(i, j, 'base')" />
                              @if (price.errors?.['basePriceInvalid']) {
                              <div class="text-danger mt-1">
                                {{ price.errors?.['basePriceInvalid'] }}
                              </div>
                              }
                            </div>
                          </div>
                          <div class="col-12 col-sm-6 col-md-3">
                            <div class="p-2">
                              <label class="mb-2">Cost Price</label>
                              <input type="number" step="0.0001" class="form-control" formControlName="costPrice"
                                (input)="calculatePricing(i, j, 'cost')" />
                            </div>
                          </div>
                          <div class="col-12 col-sm-6 col-md-3">
                            <div class="p-2">
                              <label class="mb-2">Selling Price</label>
                              <input type="number" class="form-control" formControlName="sellingPrice" />
                              @if (price.errors?.['sellingPriceInvalid']) {
                              <div class="text-danger mt-1">
                                {{ price.errors?.['sellingPriceInvalid'] }}
                              </div>
                              }
                              @if (!price.errors?.['sellingPriceInvalid'] && isZeroMargin(price)) {
                              <div class="text-warning-emphasis mt-1 small">
                                <i class="bi bi-info-circle-fill me-1"></i>
                                Zero margin — sells at cost.
                              </div>
                              }
                            </div>
                          </div>
                          <div class="col-12 col-sm-6 col-md-2">
                            <div class="p-2">
                              <label class="mb-2">Wholesale Price <small class="text-muted">(B2B)</small></label>
                              <input type="number" step="0.01" class="form-control" formControlName="wholesalePrice"
                                placeholder="Optional"
                                title="Tax-exclusive rate offered to B2B customers without a price of their own. Leave blank to sell B2B at the selling price." />
                            </div>
                          </div>
                          <div class="col-12 col-sm-6 col-md-2">
                            <div class="p-2">
                              <label class="mb-2">MRP</label>
                              <input type="number" class="form-control" formControlName="mrp"
                                (input)="calculatePricing(i, j, 'mrp')" />
                              @if (price.errors?.['mrpInvalid']) {
                              <div class="text-danger mt-1">
                                {{ price.errors?.['mrpInvalid'] }}
                              </div>
                              }
                            </div>
                          </div>
                          <div class="col-12 col-sm-6 col-md-2">
                            <div class="p-2">
                              <label class="mb-2">PLU (weighable)</label>
                              <input type="text" class="form-control" formControlName="pluCode"
                                placeholder="e.g. 12345" />
                            </div>
                          </div>
                          <div class="col-12 col-sm-6 col-md-2">
                            <div class="p-2">
                              <label class="mb-2">EAN Code <small class="text-muted">(optional)</small></label>
                              <input type="text" class="form-control ean-input" formControlName="eanCode"
                                maxlength="20" placeholder="EAN or SKU"
                                title="Code printed on the packs sold at this price, if you want it recorded on the price row. It is also tagged as a barcode of the SKU. Leave blank to keep the current barcode." />
                            </div>
                          </div>
                          <div class="col-12 col-sm-12 col-md-1 d-flex align-items-end justify-content-end">
                            <div class="p-2 w-100 d-flex justify-content-end">
                              @if (!isEdit) {
                              <button class="btn btn-sm btn-danger" type="button" (click)="removePricing(i, j)"
                                title="Remove Pricing">
                                <i class="bi bi-trash"></i>
                              </button>
                              }
                            </div>
                          </div>
                        </div>

                        <!-- <div class="col-md-3 form-group">
                    <label>Valid From</label>
                    <input type="date" class="form-control" formControlName="validFrom" />
                  </div>
                  <div class="col-md-3 form-group">
                    <label>Valid To</label>
                    <input type="date" class="form-control" formControlName="validTo" />
                  </div> -->
                      </div>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
            }
            <button type="button" class="btn btnprimary mt-3" (click)="addVariant()">
              Add Variant
            </button>
          </div>
        </form>
        <div class="stepr-btns">
          <button type="button" class="btn btnsecondary" (click)="goToStep(1)">Back</button>
          <button type="button" class="btn btnprimary" (click)="goToStep(3)">Next</button>
        </div>
      </div>

      <!-- Step 3: Review & Submit -->
      <div class="tab-pane fade review-submit" id="step3">
        <h5>Review & Submit</h5>

        <div class="row">
          <div class="col-md-6 mb-2">
            <strong>ID:</strong> {{ productForm.value.id }}
          </div>
          <div class="col-md-6 mb-2">
            <strong>Name:</strong> {{ productForm.value.name }}
          </div>
          <div class="col-md-6 mb-2">
            <strong>Short Description:</strong>
            {{ productForm.value.shortDescription }}
          </div>
          <div class="col-md-6 mb-2">
            <strong>Long Description:</strong>
            {{ productForm.value.longDescription }}
          </div>

          <div class="col-md-6 mb-2">
            <strong>Manufacturer Name:</strong>
            {{ productForm.value.manufacturerName }}
          </div>
          <div class="col-md-6 mb-2">
            <strong>Category:</strong> {{ reviewJson.categoryName }}
          </div>
          <div class="col-md-6 mb-2">
            <strong>Sub Category:</strong> {{ reviewJson.subCategoryName }}
          </div>
          <div class="col-md-6 mb-2">
            <strong>Vendor:</strong> {{ reviewJson.vendorName }}
          </div>
          <div class="col-md-6 mb-2">
            <strong>UOM:</strong> {{ productForm.value.uom }}
          </div>
          <div class="col-md-6 mb-2">
            <strong>SKU:</strong> {{ productForm.value.sku }}
          </div>
          <div class="col-md-6 mb-2">
            <strong>HSN Code:</strong> {{ productForm.value.hsnCode }}
          </div>
          <div class="col-md-6 mb-2">
            <strong>GST Slab ID:</strong> {{ productForm.value.gstSlabId }}
          </div>
          <div class="col-md-6 mb-2">
            <strong>Batch Expiry Tracking:</strong>
            {{ productForm.value.requiresBatchExpiryTracking }}
          </div>
          <div class="col-md-6 mb-2">
            <strong>Is Active:</strong> {{ productForm.value.isActive }}
          </div>
          <div class="col-md-6 mb-2">
            <strong>Flow Through:</strong> {{ productForm.value.flowThrough }}
          </div>
          <div class="col-md-6 mb-2">
            <strong>Return To Vendor:</strong>
            {{ productForm.value.returnToVendor }}
          </div>
          <div class="col-md-6 mb-2">
            <strong>Inner Packaging:</strong>
            {{ productForm.value.innerPackaging }}
          </div>
          <div class="col-md-6 mb-2">
            <strong>Outer Packaging:</strong>
            {{ productForm.value.outerPackaging }}
          </div>
          <div class="col-md-6 mb-2">
            <strong>Photo URL:</strong> {{ productForm.value.photoUrl }}
          </div>
          <div class="col-md-6 mb-2">
            <strong>Payment Terms:</strong>
            {{ productForm.value.productSpecificPaymentTerms }}
          </div>
        </div>

        <div class="mb-3 common-table mt-5">
          <h5>Variants:</h5>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Variant Name</th>
                  <th>Color</th>
                  <th>Size</th>
                  <th>Weight</th>
                  <th>Dimensions</th>
                  <th>Min Shelf Life</th>
                  <th>Shelf Life</th>
                  <th>Batch Controlled</th>
                  <th>Serial Controlled</th>
                  <th>Is Active</th>
                  <th>Pricing</th>
                </tr>
              </thead>
              <tbody>
                @for ( variant of productForm.value.variants; track i; let
                i = $index) {
                <tr>
                  <td>{{ variant.variantName }}</td>
                  <td>{{ variant.color }}</td>
                  <td>{{ variant.size }}</td>
                  <td>{{ variant.weight }}</td>
                  <td>{{ variant.dimensions }}</td>
                  <td>{{ variant.minShelfLife }}</td>
                  <td>{{ variant.shelfLife }}</td>
                  <td>{{ variant.isBatchControlled }}</td>
                  <td>{{ variant.isSerialControlled }}</td>
                  <td>{{ variant.isActive }}</td>
                  <td>
                    <button type="button" class="btn btn-link p-0" (click)="
                        showPricingIndex === i
                          ? (showPricingIndex = -1)
                          : (showPricingIndex = i)
                      ">
                      {{
                      showPricingIndex === i ? "Hide Pricing" : "Show Pricing"
                      }}
                      @if (isVariantInvalid(i)) {
                      <i class="bi bi-exclamation-circle-fill text-danger ms-1" title="Pricing Validation Error"></i>
                      }
                    </button>
                  </td>
                </tr>
                @if (showPricingIndex === i) {
                <tr>
                  <td colspan="11">
                    <table class="table table-sm table-bordered">
                      <thead>
                        <tr>
                          <th>EAN</th>
                          <th>MRP</th>
                          <th>Cost Price</th>
                          <th>Selling Price</th>
                          <th>Wholesale</th>
                          <th>Valid From</th>
                          <th>Valid To</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (price of variant.pricing; track $index) {
                        <tr>
                          <td>{{ price.eanCode }}</td>
                          <td>{{ price.mrp }}</td>
                          <td>{{ price.costPrice }}</td>
                          <td>{{ price.sellingPrice }}</td>
                          <td>{{ price.wholesalePrice ?? '-' }}</td>
                          <td>{{ price.validFrom | date : "yyyy-MM-dd" }}</td>
                          <td>{{ price.validTo | date : "yyyy-MM-dd" }}</td>
                        </tr>
                        }
                      </tbody>
                    </table>
                  </td>
                </tr>
                } }
              </tbody>
            </table>
          </div>
        </div>
        <div class="stepr-btns">
          <button type="button" class="btn btnsecondary" (click)="goToStep(2)">Back</button>
          <button type="button" class="btn btnprimary" (click)="saveProduct()">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>